
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest, apiRequest2 } from '../_helpers/apiConfig';



export const getAllCourseList = createAsyncThunk("adminApi/courseList", async (filters) => {
    const response = await apiRequest('POST', '/v1/adminApi/courseList', filters);
    return response;
});


// export const updateStatus = createAsyncThunk("/course/toggleCourseStatus",
//     async (arg, thunkAPI) => {
//         const { Payload, forReferesh } = arg;
//         const queryParams = new URLSearchParams(Payload).toString()
//         const response = await apiRequest("POST", `v1/course/toggleCourseStatus/${queryParams}`, null);
//         if (response.message) {
//             thunkAPI.dispatch(getAllCourseList(forReferesh));
//         }
//         return response;S
//     }
// );



export const updateCourseStatus = createAsyncThunk("/adminApi/updateCourseStatus",
  async (arg, thunkAPI) => {
    const { Payload, forReferesh } = arg;
    const response = await apiRequest("POST", "v1/adminApi/updateCourseStatus", Payload);
    if (response.message) {
      thunkAPI.dispatch(getAllCourseList(forReferesh));

    }
    return response;
  }
);


export const toggleCourseDelete = createAsyncThunk("/course/toggleCourseStatus",
    async (arg, thunkAPI) => {
        const { Payload, forReferesh } = arg;


        const queryParams = new URLSearchParams(Payload).toString();
    
        console.log('Filters and Query Params:',Payload);
        const url = `v1/course/toggleCourseStatus/${Payload}`;
        const response = await apiRequest2("POST", url, null);
        console.log(response)
        if (response.message) {
            thunkAPI.dispatch(getAllCourseList(forReferesh)); // Dispatch refresh action
        }

        return response;
    }
);




const contentSlice = createSlice({
    name: 'content',
    initialState: {
        content: [],
        totalContent: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllCourseList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllCourseList.fulfilled, (state, action) => {
                state.loading = false;
                state.content = action?.payload?.data?.list;
                state.totalContent = action?.payload?.data?.total;

            })
            .addCase(getAllCourseList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(updateCourseStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCourseStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.contentStatusUpdate = action?.payload;

            })
            .addCase(updateCourseStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })






    },
});

export default contentSlice.reducer;